export default "__VITE_ASSET__aa8519ca__"